<template>
<div>
    <div id="pv" class="wrapper">
        <!-- 内容は以下に記述して下さい。 -->
        <!-- 太陽光発電 -->
        <app-error-list />
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="太陽光発電">1</parts-arrow>
                <span>太陽光発電設備の設置の有無等を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="太陽光発電設備"
                class="flex_column"
                name="pv_saiyou"
                @click="guideTransition"
                url="https://house.lowenergy.jp/program#double_power_generation"
            >
                <app-radio
                    v-for="value in ['2','1']"
                    v-model="pv_saiyou"
                    :value="value"
                    unit=""
                    :key="'pv_saiyou' + value"
                >
                    {{master.pv_saiyou[value]}}
                </app-radio>
                <information-box title="太陽光発電設備を設置する場合">
                    年間の日射地域区分の指定が必要です。
                </information-box>
                <information-box title="太陽光発電設備とコージェネレーション設備を同時に設置する場合">
                    太陽光発電設備は、太陽光タブにおいて
                        <a
                            href="https://house.lowenergy.jp/dictionary/PV"
                            target="_blank"
                            class="target_blank"
                        >
                            こちら
                        </a>を参考に入力します。<br/>
                    コージェネレーション設備は、コージェネタブにおいて
                        <a
                            href="https://house.lowenergy.jp/dictionary/cogene"
                            target="_blank"
                            class="target_blank"
                        >
                            こちら
                        </a>を参考に入力します。<br/>
                    
                </information-box>
            </app-box>
            <app-box
                label="方位の異なるパネルの面数"
                name="pv_panelsuu"
                @click="guideTransition"
                :available="true"
                v-if="pv_saiyou == '1'"
            >
                <app-radio
                    v-for="count in 4"
                    v-model="pv_panelsuu"
                    :value="count.toString()"
                    label="1"
                    unit=""
                    :key="count"
                >
                    {{count}}面
                </app-radio>
            </app-box>
            <app-box
                label="パワーコンディショナの定格負荷効率の入力"
                name=""
                :available="true"
                v-if="pv_saiyou == '1'"
            >
                <app-radio
                    v-for="(name, value) in master.pv_pcs_koritsu"
                    v-model="pv_pcs_koritsu"
                    :value="value"
                    unit=""
                    :key="'pv_pcs_koritsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                label="パワーコンディショナの定格負荷効率"
                name="pv_pcs_koritsu_e"
                @click="guideTransition"
                :available="true"
                v-if="pv_pcs_koritsu == '2' && pv_saiyou == '1'"
            >
                <app-text
                    v-model="pv_pcs_koritsu_e"
                    label=""
                    unit="%"
                    subscript="(小数点以下1桁)"
                    :step="0.1"
                    class="number"
                />
            </app-box>
        </app-section>

        <div v-if="pv_saiyou == '1'">
            <!-- パネル1 -->
            <app-section v-if="pv_panelsuu >= 1">
                <h3 slot="h3">
                    <parts-arrow category="太陽光発電">2</parts-arrow>
                    <span>パネルその1の評価方法を入力して下さい。</span>
                </h3>
                <app-box
                    :available="true"
                    label="太陽電池アレイのシステム容量"
                    class="flex_column"
                    name="pv_panel_youryo"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="pv_panel1_youryo"
                        label=""
                        unit="kW"
                        subscript="(小数点以下2桁)"
                        :step="0.01"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="太陽電池アレイの種類"
                    class="flex_"
                    name="pv_panel_shurui"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_shurui"
                        v-model="pv_panel1_shurui"
                        :value="value"
                        unit=""
                        :key="'pv_panel1_shurui' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="太陽電池アレイ設置方式"
                    class="flex_row"
                    name="pv_panel_setti"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_setti"
                        v-model="pv_panel1_setti"
                        :value="value"
                        unit=""
                        :key="'pv_panel1_setti' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="パネルの設置方位角"
                    class="flex_column"
                    name="pv_panel_houi"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_houi"
                        v-model="pv_panel1_houi"
                        :value="value"
                        unit=""
                        :key="'pv_panel1_houi' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="パネル設置傾斜角"
                    class="flex_column"
                    name="pv_panel_keisha"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_keisha"
                        v-model="pv_panel1_keisha"
                        :value="value"
                        unit=""
                        :key="'pv_panel1_keisha' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
            </app-section>

            <!-- パネル2 -->
            <app-section v-if="pv_panelsuu >= 2">
                <h3 slot="h3">
                    <parts-arrow category="太陽光発電">3</parts-arrow>
                    <span>パネルその2の評価方法を入力して下さい。</span>
                </h3>
                <app-box
                    :available="true"
                    label="太陽電池アレイのシステム容量"
                    class="flex_column"
                    name="pv_panel_youryo"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="pv_panel2_youryo"
                        label=""
                        unit="kW"
                        subscript="(小数点以下2桁)"
                        :step="0.01"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="太陽電池アレイの種類"
                    class="flex_"
                    name="pv_panel_shurui"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_shurui"
                        v-model="pv_panel2_shurui"
                        :value="value"
                        unit=""
                        :key="'pv_panel2_shurui' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="太陽電池アレイ設置方式"
                    class="flex_row"
                    name="pv_panel_setti"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_setti"
                        v-model="pv_panel2_setti"
                        :value="value"
                        unit=""
                        :key="'pv_panel2_setti' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="パネルの設置方位角"
                    class="flex_column"
                    name="pv_panel_houi"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_houi"
                        v-model="pv_panel2_houi"
                        :value="value"
                        unit=""
                        :key="'pv_panel2_houi' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="パネル設置傾斜角"
                    class="flex_column"
                    name="pv_panel_keisha"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_keisha"
                        v-model="pv_panel2_keisha"
                        :value="value"
                        unit=""
                        :key="'pv_panel2_keisha' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
            </app-section>
            
            <!-- パネル3 -->
            <app-section v-if="pv_panelsuu >= 3">
                <h3 slot="h3">
                    <parts-arrow category="太陽光発電">4</parts-arrow>
                    <span>パネルその3の評価方法を入力して下さい。</span>
                </h3>
                <app-box
                    :available="true"
                    label="太陽電池アレイのシステム容量"
                    class="flex_column"
                    name="pv_panel_youryo"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="pv_panel3_youryo"
                        label=""
                        unit="kW"
                        subscript="(小数点以下2桁)"
                        :step="0.01"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="太陽電池アレイの種類"
                    class="flex_"
                    name="pv_panel_shurui"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_shurui"
                        v-model="pv_panel3_shurui"
                        :value="value"
                        unit=""
                        :key="'pv_panel3_shurui' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="太陽電池アレイ設置方式"
                    class="flex_row"
                    name="pv_panel_setti"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_setti"
                        v-model="pv_panel3_setti"
                        :value="value"
                        unit=""
                        :key="'pv_panel3_setti' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="パネルの設置方位角"
                    class="flex_column"
                    name="pv_panel_houi"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_houi"
                        v-model="pv_panel3_houi"
                        :value="value"
                        unit=""
                        :key="'pv_panel3_houi' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="パネル設置傾斜角"
                    class="flex_column"
                    name="pv_panel_keisha"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_keisha"
                        v-model="pv_panel3_keisha"
                        :value="value"
                        unit=""
                        :key="'pv_panel3_keisha' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
            </app-section>
            
            <!-- パネル4 -->
            <app-section v-if="pv_panelsuu >= 4">
                <h3 slot="h3">
                    <parts-arrow category="太陽光発電">5</parts-arrow>
                    <span>パネルその4の評価方法を入力して下さい。</span>
                </h3>
                <app-box
                    :available="true"
                    label="太陽電池アレイのシステム容量"
                    class="flex_column"
                    name="pv_panel_youryo"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="pv_panel4_youryo"
                        label=""
                        unit="kW"
                        subscript="(小数点以下2桁)"
                        :step="0.01"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    label="太陽電池アレイの種類"
                    class="flex_"
                    name="pv_panel_shurui"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_shurui"
                        v-model="pv_panel4_shurui"
                        :value="value"
                        unit=""
                        :key="'pv_panel4_shurui' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="太陽電池アレイ設置方式"
                    class="flex_row"
                    name="pv_panel_setti"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_setti"
                        v-model="pv_panel4_setti"
                        :value="value"
                        unit=""
                        :key="'pv_panel4_setti' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="パネルの設置方位角"
                    class="flex_column"
                    name="pv_panel_houi"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_houi"
                        v-model="pv_panel4_houi"
                        :value="value"
                        unit=""
                        :key="'pv_panel4_houi' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    label="パネル設置傾斜角"
                    class="flex_column"
                    name="pv_panel_keisha"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.pv_panel_keisha"
                        v-model="pv_panel4_keisha"
                        :value="value"
                        unit=""
                        :key="'pv_panel4_keisha' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
            </app-section>
        </div>
        <!-- 内容ここまで -->
    </div>
</div>
</template>

<script>
/**
 * 詳細版太陽光発電情報入力画面
 * 
 * [算出プロパティ]
 * 詳細版インタフェイス定義の同名項目に準ずる
 * 
 * [イベント処理]
 * インタフェイス定義済み項目の更新時 ... Storeの該当するキーのデータも更新される
 */
import help from "@/mixins/help"
import master from "@/mixins/master"
import { mapGetters, mapActions } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name:"PageManualPhotovoltaic",
    computed: {
        ...mapGetters('data', {
            data:'getData',
        }),
        ...mapComputedProperties([
            'pv_saiyou',
            'pv_panelsuu',
            'pv_pcs_koritsu',
            'pv_pcs_koritsu_e',
            'pv_panel1_youryo',
            'pv_panel1_shurui',
            'pv_panel1_setti',
            'pv_panel1_houi',
            'pv_panel1_keisha',
            'pv_panel2_youryo',
            'pv_panel2_shurui',
            'pv_panel2_setti',
            'pv_panel2_houi',
            'pv_panel2_keisha',
            'pv_panel3_youryo',
            'pv_panel3_shurui',
            'pv_panel3_setti',
            'pv_panel3_houi',
            'pv_panel3_keisha',
            'pv_panel4_youryo',
            'pv_panel4_shurui',
            'pv_panel4_setti',
            'pv_panel4_houi',
            'pv_panel4_keisha'
        ])
    },
    mixins:[help, master],
    methods:{
        ...mapActions('data', ['update']),
    }
}
</script>

<style scoped>
</style>

